import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function CodeSnippetCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("codeSnippetCard.title")}</h1>
      <p>{t("codeSnippetCard.intro")}</p>

      <CodeBlock title="codeSnippetImage()">{`import { codeSnippetImage } from "kira-arts";

const buffer = await codeSnippetImage(
  \`const greet = (name) => \\\`Hello, \\\${name}!\\\`;

console.log(greet("World"));\`,
  {
    language: "typescript",
    fileName: "greet.ts",
    theme: "synthwave",
  },
);`}</CodeBlock>

      <h2>{t("codeSnippetCard.optionsTitle")}</h2>
      <CodeBlock title="CodeSnippetOptions">{`language?: "javascript" | "typescript" | "python" | "java" | "csharp" | "json" | "bash" | "plaintext";
fileName?: string;
windowTitle?: string;
theme?: "midnight" | "dracula" | "nord" | "github" | "monokai" | "synthwave";
showLineNumbers?: boolean;
startLine?: number;
highlightLines?: number[];
accentColor?: string;`}</CodeBlock>

      <h2>{t("codeSnippetCard.themesTitle")}</h2>
      <p>
        <Trans i18nKey="codeSnippetCard.themesNote" components={[<code key="0" />]} />
      </p>

      <h2>{t("codeSnippetCard.highlightTitle")}</h2>
      <p>
        <Trans i18nKey="codeSnippetCard.highlightNote" components={[<code key="0" />]} />
      </p>

      <CodeBlock title="highlighting an error line">{`const buffer = await codeSnippetImage(code, {
  language: "javascript",
  fileName: "server.js",
  highlightLines: [9, 10, 11],
});`}</CodeBlock>

      <p>{t("codeSnippetCard.sizingNote")}</p>
    </article>
  );
}
